<template>
  <div class="header-page">
    <!--收拢/展开菜单-->
    <div class="switch-collapse-box contour">
      <el-button :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                 :title="isCollapse ? '展开' : '收缩'"
                 class="collapse-btn" type="text"
                 @click="switchCollapse">
      </el-button>
    </div>
<!--    <div class="breadcrumb-box contour">-->
<!--      <Breadcrumb/>-->
<!--    </div>-->
    <div class="avatar-box contour">
      <avatar-menu/>
    </div>
    <div class="nickName-box contour">
      <span>{{ nickName }}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Breadcrumb from './components/Breadcrumb'
  import AvatarMenu from "./components/AvatarMenu"
  export default {
    name: "HeaderPage",
    components: {AvatarMenu},
    data() {
      return {
        nickName: this.$store.state.nickName
      }
    },
    computed: {
      ...mapGetters([
        'isCollapse'
      ])
    },
    methods: {
      switchCollapse() {
        this.$store.commit("switchCollapse")
      }
    }
  }
</script>

<style scoped lang="scss">
  .header-page {
    box-sizing: border-box;
    height: $header-height;
    background: $header-color;
    padding: 0 20px 0 0;
    border-bottom: 1px solid transparent;
    /*border-bottom: 1px solid #d8dce5;*/
    /*box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);*/
    .switch-collapse-box {
      float: left;
      margin-left: 10px;
      height: 100%;
      .collapse-btn {
        vertical-align: middle;
        font-size: 25px;
        color: #304156;
      }
    }
    .breadcrumb-box {
      margin-left: 20px;
      float: left;
      height: 100%;
    }
    .avatar-box {
      float: right;
      height: 100%;
      cursor: pointer;
    }
    .nickName-box {
      float: right;
      height: 100%;
      margin-right: 10px;
      span {
        color: #304156;
        vertical-align: middle;
      }
    }
  }
</style>
